import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b4cf5dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "u-tabs" }
const _hoisted_2 = ["onClick", "onContextmenu"]
const _hoisted_3 = { class: "select-none" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"
  })
], -1))

import { nextTick, onMounted, reactive, ref, toRef, watch } from 'vue'
import ContextMenu from './context-menu.vue'
import { TagApi } from '.'

interface Props {
  classic?: boolean
  modelValue: TagApi[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'tags',
  props: {
    classic: { type: Boolean },
    modelValue: null
  },
  emits: ["select", "refresh", "close", "closeOther", "closeAll", "fullScreen"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'select', val: TagApi | undefined): void
  (e: 'refresh', val: TagApi): void
  (e: 'close', tag: TagApi): void
  (e: 'closeOther', tag: TagApi): void
  (e: 'closeAll'): void
  (e: 'fullScreen', tag: TagApi): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  classic?: boolean
  modelValue: TagApi[]
}



const scrollbarRef = ref()
const contextmenuRef = ref()
// 将这个属性转换为响应式数据。
const tagsList = toRef(props, 'modelValue')
const active = ref(0)
const dropdown = reactive({
  x: 0,
  y: 0
})



watch(
  () => [...tagsList.value],
  (val, oldVal) => {
    if (oldVal) {
      if (val.length > oldVal.length) {
        //新增目标元素id
        let tag = val.find(v => !oldVal?.includes(v))
        // 删除相同的元素
        tagsList.value.forEach((item, index, self) => {
          if (self.findIndex(v => v.meta.title == item.meta.title) != index) {
            self.splice(index, 1)
          }
        })
        active.value = tagsList.value.findIndex(v => v.meta.title == tag?.meta.title)
      }
    } else {
      let flag = 1
      // 删除相同的元素
      tagsList.value.forEach((item, index, self) => {
        if (self.findIndex(v => v.meta.title == item.meta.title) != index) {
          self.splice(index, 1)
          active.value = self.findIndex(v => v.meta.title == item.meta.title)
          flag = 0
        }
      })
      if (flag) active.value = tagsList.value.length - 1
    }

    nextTick(() => {
      scrollbarRef.value.update()
    })
  },
  {
    immediate: true
  }
)

watch(
  () => active.value,
  val => {
    emit(
      'select',
      tagsList.value.find((v, k) => k == val)
    )
  }
)

const close = (val: number) => {
  tagsList.value.map((v, k) => {
    if (!v.meta.isAffix && val == k) {
      tagsList.value.splice(k, 1)
      if (k == active.value) {
        let arr = [k, k - 1]
        let indexs = arr.filter(v => v >= 0 && v < tagsList.value.length)
        active.value = indexs[0]
        if (active.value == k) {
          emit(
            'select',
            tagsList.value.find((v, k) => k == val)
          )
        }
      } else if (val < active.value) {
        active.value -= 1
      }
    }
  })
}

const closeOther = (val?: TagApi) => {
  let newList = tagsList.value.filter(v => v.meta.isAffix)
  if (val && !val.meta.isAffix) {
    newList.push(val)
  }
  tagsList.value.length = 0
  tagsList.value.push(...newList)
  let target = tagsList.value.length - 1
  active.value = target >= 0 ? target : 0
}

const onSubmit = (val: number, tag: TagApi) => {
  let index = null
  switch (val) {
    case 0:
      // 刷新当前
      emit('refresh', tag)
      break
    case 1:
      // 关闭当前
      index = tagsList.value.findIndex(v => (v.path == tag.path))
      close(index)
      emit('close', tag)
      break
    case 2:
      // 关闭其他
      closeOther(tag)
      emit('closeOther', tag)
      break
    case 3:
      // 全部关闭
      closeOther()
      emit('closeAll')
      break
    case 4:
      // 全屏
      emit('fullScreen', tag)
      break
  }
}

const onContextmenu = (v: TagApi, e: MouseEvent) => {
  const { clientX, clientY } = e
  dropdown.x = clientX
  dropdown.y = clientY
  contextmenuRef.value.openContextmenu(v)
}

return (_ctx: any,_cache: any) => {
  const _component_u_icon = _resolveComponent("u-icon")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_scrollbar, {
      ref_key: "scrollbarRef",
      ref: scrollbarRef
    }, {
      default: _withCtx(() => [
        _createElementVNode("ul", {
          class: _normalizeClass([{ 'classic-style': __props.classic }, "u-tabs-ul"])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modelValue, (v, k) => {
            return (_openBlock(), _createElementBlock("li", {
              key: k,
              class: _normalizeClass([{ 'is-active': active.value == k }, "u-tabs-ul-li"]),
              onClick: ($event: any) => (active.value = k),
              onContextmenu: _withModifiers(($event: any) => (onContextmenu(v, $event)), ["prevent"])
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(v.meta.title), 1),
              (!v.meta.isAffix)
                ? (_openBlock(), _createBlock(_component_u_icon, {
                    key: 0,
                    onClick: _withModifiers(($event: any) => (onSubmit(1, v)), ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ], 42, _hoisted_2))
          }), 128))
        ], 2)
      ]),
      _: 1
    }, 512),
    _createVNode(ContextMenu, {
      ref_key: "contextmenuRef",
      ref: contextmenuRef,
      dropdown: dropdown,
      onSubmit: onSubmit
    }, null, 8, ["dropdown"])
  ]))
}
}

})